import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext, useEffect, useState } from 'react'

const Context = createContext(false)

export const BrowserRenderProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [isBrowserRender, setIsBrowserRender] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsBrowserRender(true)
    }, 1)
  }, [])

  return <Context.Provider value={isBrowserRender}>{children}</Context.Provider>
}

export const useIsBrowserRender = () => {
  const ctxval = useContext(Context)
  return ctxval
}
